import { HomeSiloIcon } from './HomeSiloIcon';

/**
 * author: Jeff Anders
 * id 1F67690D-B143-4CF0-9888-54F647E62F33
 * name home-silo
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-silo.svg
 * tags
 * - Home Automation 
 * - Agriculture 
 */
export const FarmHouseIcon = HomeSiloIcon;
export default FarmHouseIcon